module.exports = __webpack_public_path__ + "static/borrowBannerBackground-0e9d82003f8ad3ce7faf9ae321c59bd3.svg";